<template>
  <v-row>
    <v-col class="col-12">
      <div v-if="!disableDescription">
        {{ $t('singleProductView.imageDescription') }}
      </div>
      <v-form ref="uploadForm">
        <v-img
          v-if="compImgLink"
          :src="compImgLink"
          :aspect-ratio="3 / 2"
          class="grey lighten-2 justify-end"
          max-width="500"
        >
          <v-layout v-if="allowRemoval" class="justify-end ma-2">
            <v-btn color="error" class="pa-2" small @click="cleared">
              <i class="fas fa-trash"></i>
            </v-btn>
          </v-layout>
        </v-img>
        <v-file-input
          v-if="!disableReplacement"
          ref="fileUploadInput"
          :rules="rules"
          accept="image/png, image/jpeg"
          prepend-icon="image"
          :label="label"
          show-size
          @change="uploadImage"
        />
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import FileUploadService from '../../classes-shared/files/FileUploadService'

export default {
  name: 'ImageUploader',
  props: {
    initialImageLink: {
      type: String,
      default: '',
    },
    disableDescription: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    label: {
      type: String,
      default: '',
    },
    allowRemoval: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    disableReplacement: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    contextData: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      uploadService: new FileUploadService(),
      imageLink: '',
      chosenFile: null,
      rules: [
        (value) => !!value || i18n.t('imageUploader.required'),
        (value) => {
          if (
            value &&
            !(value.type === 'image/jpeg' || value.type === 'image/png')
          ) {
            return i18n.t('imageUploader.wrongFileType')
          }

          if (value && value.size > 1000000) {
            return i18n.t('singleProductView.maxImageSize')
          }

          return true
        },
      ],
    }
  },
  computed: {
    compImgLink: function () {
      return this.initialImageLink
    },
  },
  methods: {
    async uploadImage(file) {
      if (file && this.$refs.uploadForm.validate()) {
        const uploadedFile = await this.uploadService.uploadImage(file)
        this.$refs.fileUploadInput.reset()
        this.imageLink = uploadedFile.getImageUrl()
        this.$emit('uploaded', uploadedFile, this.contextData)
      }
    },
    cleared() {
      this.imageLink = ''
      if (!this.disableReplacement) {
        this.$refs.fileUploadInput.reset()
      }
      this.$emit('cleared', this.contextData)
    },
  },
}
</script>
